module.exports = __webpack_public_path__ + "static/media/honda_logo_white.9f89dbb9.svg";